window.coupons = {
    setup () {
        // Nothing
    },

    /**
     * Submit Apply Coupon Form
     *
     * @param event
     */
    submitApplyCouponForm: function (event) {
        event.preventDefault();

        //
        // Clear Error Messages
        //
        let errorMapping = {
            'coupon': 'coupon',
        };

        for (let i = 0; i < Object.keys(errorMapping).length; i++) {
            let value = errorMapping[Object.keys(errorMapping)[i]];
            document.querySelector('[data-error-' + value +']').style.display = 'none';
            document.querySelector('[data-error-' + value +']').innerText = '';
        }

        $.ajax({
            url: window.loginEndpoint + '/profile/coupon',
            type: 'PUT',
            headers: {Authorization: 'Bearer ' + window.authorisation.getToken()},
            data: {
                coupon: document.querySelector('[data-input-coupon]').value,
            },
            success: () => {
                // Get the value of the URL parameter redirect_url
                let queryString = window.location.search;
                let urlParams = new URLSearchParams(queryString);
                let redirectUrl = urlParams.get('redirect_url');

                if (redirectUrl) {
                    window.location = window.loginEndpoint + '/sso/refresh' + '?redirect_url=' + redirectUrl;
                } else {
                    window.location = window.loginEndpoint + '/sso/refresh' + '?redirect_url=' + encodeURIComponent(window.location.href + '?applied_coupon=true')
                }
            },
            error: (result) => {
                //
                // If we received errors, present them
                //
                for (let i = 0; i < Object.keys(errorMapping).length; i++) {
                    let key = Object.keys(errorMapping)[i];
                    let value = errorMapping[Object.keys(errorMapping)[i]];

                    if (key in result.responseJSON) {
                        let message = result.responseJSON[key].join('. ');
                        document.querySelector('[data-error-' + value +']').style.display = 'block';
                        document.querySelector('[data-error-' + value +']').innerText = message
                    }
                }

            },
        });
    },

    /**
     * Submit Create Coupon Form
     *
     * @param event
     */
    submitCreateCouponForm: function (event) {
        event.preventDefault();

        //
        // Clear Error Messages
        //

        $.ajax({
            url: window.loginEndpoint + '/profile/coupon',
            type: 'POST',
            headers: {Authorization: 'Bearer ' + window.authorisation.getToken()},
            data: {},
            success: (response) => {
                if (response.coupon) {
                    // Set value
                    document.querySelector('[data-coupon-value-input]').value = response.coupon;
                    // Change states
                    document.querySelector('.account-create-coupon').classList.remove('account-create-coupon--error');
                    document.querySelector('.account-create-coupon').classList.add('account-create-coupon--success');
                }
            },
            error: (result) => {
                console.log(result, result.responseJSON);
                if (result.responseJSON.message) {
                    // Set value
                    document.querySelector('[data-coupon-error]').innerText = result.responseJSON.message;
                    // Change states
                    document.querySelector('.account-create-coupon').classList.add('account-create-coupon--error');
                    document.querySelector('.account-create-coupon').classList.remove('account-create-coupon--success');
                }
            },
        });
    },

    copyCreateCouponValue: function () {
        // Get the text field
        let copyText = document.querySelector('[data-coupon-value-input]');

        // Select the text field
        copyText.select();
        copyText.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText.value);

        document.querySelector('.account-create-coupon__success-copy').innerText = 'Copied';
    },
}
